import { ChildAccountDisplayObject } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export const removeName = (
  childAccounts: ChildAccountDisplayObject[],
  keyOfNameToRemove: string
): ChildAccountDisplayObject[] => {
  return childAccounts.filter(
    (account) => account.uniqueDisplayKey !== keyOfNameToRemove
  );
};
